import React from "react";

export default class User extends React.Component {

  public render(): React.ReactNode {
    return <div>User</div>;
  }

}